var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 125,
    viewBox: "0 0 149 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.075 59.1058C132.075 74.3936 125.839 88.1742 115.841 98.079C106.058 107.876 92.5113 113.797 77.5674 113.797C62.731 113.797 49.1848 107.768 39.2938 98.079C29.2954 88.1742 23.0598 74.3936 23.0598 59.1058C23.0598 28.8531 47.4646 4.41406 77.5674 4.41406C107.67 4.41406 132.075 28.9607 132.075 59.1058Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.345 23.2547C129.779 23.2547 131.753 21.2784 131.753 18.8406C131.753 16.4028 129.779 14.4265 127.345 14.4265C124.91 14.4265 122.937 16.4028 122.937 18.8406C122.937 21.2784 124.91 23.2547 127.345 23.2547Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.795 6.02901C135.457 6.02901 136.805 4.67937 136.805 3.0145C136.805 1.34964 135.457 0 133.795 0C132.132 0 130.785 1.34964 130.785 3.0145C130.785 4.67937 132.132 6.02901 133.795 6.02901Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7801 23.1469C26.4426 23.1469 27.7903 21.7973 27.7903 20.1324C27.7903 18.4676 26.4426 17.1179 24.7801 17.1179C23.1175 17.1179 21.7698 18.4676 21.7698 20.1324C21.7698 21.7973 23.1175 23.1469 24.7801 23.1469Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39594 81.2839C9.4835 81.2839 11.9865 78.7774 11.9865 75.6855C11.9865 72.5936 9.4835 70.0872 6.39594 70.0872C3.30838 70.0872 0.80542 72.5936 0.80542 75.6855C0.80542 78.7774 3.30838 81.2839 6.39594 81.2839Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8948_38695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.29 27.7576V87.4069C126.29 89.8895 124.305 91.8564 121.872 91.8564H32.1498C29.717 91.8564 27.7004 89.8573 27.7004 87.4069V27.7576C27.7004 25.3072 29.685 23.3081 32.1498 23.3081H121.872C124.305 23.3081 126.29 25.3072 126.29 27.7576Z",
    fill: "url(#paint0_linear_8948_38695)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.29 27.7576V34.4319H27.7004V27.7576C27.7004 25.3072 29.685 23.3081 32.1498 23.3081H121.872C124.305 23.3081 126.29 25.3072 126.29 27.7576Z",
    fill: "#D5DDEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9103 30.5305C34.8296 30.5305 35.5748 29.7798 35.5748 28.8539C35.5748 27.9279 34.8296 27.1772 33.9103 27.1772C32.9911 27.1772 32.2458 27.9279 32.2458 28.8539C32.2458 29.7798 32.9911 30.5305 33.9103 30.5305Z",
    fill: "#989FB0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.352 30.5305C40.2713 30.5305 41.0165 29.7798 41.0165 28.8539C41.0165 27.9279 40.2713 27.1772 39.352 27.1772C38.4327 27.1772 37.6875 27.9279 37.6875 28.8539C37.6875 29.7798 38.4327 30.5305 39.352 30.5305Z",
    fill: "#989FB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7617 30.5305C45.6809 30.5305 46.4262 29.7798 46.4262 28.8539C46.4262 27.9279 45.6809 27.1772 44.7617 27.1772C43.8424 27.1772 43.0972 27.9279 43.0972 28.8539C43.0972 29.7798 43.8424 30.5305 44.7617 30.5305Z",
    fill: "#989FB0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2825 75.0579H105.707",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3411 81.2163H96.6487",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3918 57.7115V61.0325H65.3752V64.2245H61.5981V61.0325H53.2756V57.2278L60.9899 46.4265H65.4072V57.7437H67.3918V57.7115ZM61.5981 50.8438L56.7967 57.7115H61.5981V50.8438Z",
    fill: "url(#paint1_linear_8948_38695)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8666 64.5792C72.8334 64.5792 69.2804 61.0325 69.2804 55.2933C69.2804 49.554 72.8014 46.0073 76.8666 46.0073C80.9318 46.0073 84.4528 49.554 84.4528 55.2933C84.4528 61.0325 80.9318 64.5792 76.8666 64.5792ZM76.8666 61.1614C78.7552 61.1614 80.6437 59.2591 80.6437 55.3255C80.6437 51.3919 78.7552 49.4895 76.8666 49.4895C74.978 49.4895 73.0895 51.3919 73.0895 55.3255C73.0895 59.2591 74.978 61.1614 76.8666 61.1614Z",
    fill: "url(#paint2_linear_8948_38695)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.746 57.7115V61.0325H98.7291V64.2245H94.952V61.0325H86.6295V57.2278L94.3438 46.4265H98.7611V57.7437H100.746V57.7115ZM94.9199 50.8438L90.1185 57.7115H94.9199V50.8438Z",
    fill: "url(#paint3_linear_8948_38695)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.93 105.028L100.485 83.5701L105.402 78.647L126.829 100.122L121.93 105.028Z",
    fill: "#858B9B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.385 112.578L112.941 96.1109C111.568 94.7359 111.568 92.495 112.941 91.1199C114.314 89.7449 116.552 89.7449 117.925 91.1199L134.369 107.587C135.742 108.962 135.742 111.203 134.369 112.578C132.996 113.953 130.758 113.953 129.385 112.578Z",
    fill: "#858B9B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M128.215 113.63L107.058 92.4442C106.567 91.9519 106.567 91.154 107.058 90.6447L112.466 85.2293C112.958 84.737 113.755 84.737 114.263 85.2293L135.42 106.416C135.911 106.908 135.911 107.706 135.42 108.215L130.012 113.63C129.503 114.123 128.707 114.123 128.215 113.63Z",
    fill: "url(#paint4_linear_8948_38695)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2096 14.426C53.7646 14.426 35.5747 32.6415 35.5747 55.1179C35.5747 77.5774 53.7646 95.8098 76.1927 95.8098C98.6376 95.8098 116.828 77.5944 116.828 55.1179C116.828 32.6415 98.6376 14.426 76.2096 14.426ZM76.2096 88.2724C58.1892 88.2724 43.5932 73.4182 43.5932 55.1009C43.5932 36.7836 58.1892 21.9465 76.2096 21.9465C94.23 21.9465 108.826 36.8006 108.826 55.1179C108.826 73.4352 94.2131 88.2724 76.2096 88.2724Z",
    fill: "url(#paint5_linear_8948_38695)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8948_38695",
    x: 5.70044,
    y: 12.3081,
    width: 142.589,
    height: 112.548,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8948_38695"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8948_38695",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8948_38695",
    x1: 76.9629,
    y1: 21.7225,
    x2: 76.9629,
    y2: 92.5954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8948_38695",
    x1: 84.625,
    y1: 46.0073,
    x2: 88.1816,
    y2: 64.5773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8948_38695",
    x1: 84.625,
    y1: 46.0073,
    x2: 88.1816,
    y2: 64.5773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8948_38695",
    x1: 84.625,
    y1: 46.0073,
    x2: 88.1816,
    y2: 64.5773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8948_38695",
    x1: 106.676,
    y1: 99.4331,
    x2: 135.794,
    y2: 99.4331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8948_38695",
    x1: 35.5375,
    y1: 55.1268,
    x2: 116.842,
    y2: 55.1268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/PageNotFound.f4dd650b72fd8b67d642e7e0323b2681.svg";
export { ForwardRef as ReactComponent };